import React, { useEffect, useState } from 'react';
import Header from '../components/resuableComponents/Header';
import Footer from '../components/resuableComponents/Footer';
import { AutoComplete, Divider } from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Container, Grid } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { DatePicker, Space } from 'antd';
import { Modal } from 'antd';
import type { DatePickerProps } from 'antd';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Skeleton from '@mui/material/Skeleton';
import { Button } from 'antd';
import {
	fetchCityDispatch,
	AddSearchFlightDispatch,
} from '../reducers/HomeReducer';
import { useLocation, useNavigate } from 'react-router-dom';
import FlightResultSkeleton from '../components/resuableComponents/FlightResultSkeleton';
import TopDrawer from '../components/resuableComponents/TopDrawer';
import { AddSearchFlightFDDispatch } from '../reducers/FDReducer';
const Option = AutoComplete.Option;
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const SearchResultPromo = () => {
	const { city, loadinghome } = useSelector((state) => state.home);
	const { tboflight, loading } = useSelector((state) => state.tbo);
	const { fdresult, loadingfd, holdresult } = useSelector((state) => state.aiq);
	const dispatch = useDispatch();
	const [departDate, setDepartDate] = useState('');
	const [draw, setDraw] = useState(false);
	const [loadings, setLoading] = useState(false);
	const [open, setOpen] = useState(false);
	const [scrollVal, SetScrollVal] = useState(10);
	const [hasMorefilterData, SethasMoreFilterData] = useState(true);
	const navigate = useNavigate();
	const location = useLocation();
	console.log('location', location);
	const onChange: DatePickerProps['onChange'] = (date, dateString) => {
		console.log(date, dateString);
		setDepartDate(dateString);
	};
	const showModal = () => {
		setOpen(true);
	};

	const handleOk = () => {
		setLoading(true);
		setTimeout(() => {
			setLoading(false);
			setOpen(false);
		}, 3000);
	};

	const handleCancel = () => {
		setOpen(false);
	};
	const fetchMoreData = () => {
		// if (eltbo === fals && letrav === false && trp === false) {
		// 	if (scrollVal >= filterData.length) {
		// 		SethasMoreFilterData(false);
		// 	}
		// }

		setTimeout(() => {
			SetScrollVal(scrollVal + 5);
		}, 500);
	};
	const opsList =
		city?.result?.length > 0 &&
		city.result?.map((l) => {
			return (
				<Option
					value={`${l.airport_code} - ${l.city_name}`}>{`${l.airport_code} - ${l.city_name} , ${l.country_name}`}</Option>
			);
		});
	const handleChange = (value) => {
		let values = value.toLowerCase();
		let cityData = {
			keywords: values,
			limits: 10,
		};
		dispatch(fetchCityDispatch(cityData));
	};
	let filterData = [];
	let combineflightData = [];
	let filterAirlineTBO = [];
	let filterAirlineETR = [];
	let filterAirlineAIQ = [];
	let combineAirlineCode = [];
	if (tboflight) {
		tboflight &&
			tboflight?.result &&
			tboflight?.result?.Response &&
			tboflight?.result?.Response?.Results[0].length > 0 &&
			tboflight?.result?.Response?.Results[0].map((item) => {
				if (item?.FareClassification?.Type === 'Inst_SeriesPurPF2') {
					combineflightData.push({
						...item,
					});
				}
			});
	}
	if (fdresult?.result === 'No result found!') {
	} else {
		fdresult &&
			fdresult?.result &&
			fdresult?.result?.length > 0 &&
			fdresult?.result?.map((item) => {
				combineflightData.push({
					...item,
				});
			});
	}
	if (holdresult) {
		holdresult &&
			holdresult?.searchResult &&
			holdresult?.searchResult.length > 0 &&
			holdresult?.searchResult.map((item) => {
				combineflightData.push({
					...item,
				});
			});
	}
	if (combineflightData && combineflightData.length > 0) {
		filterData =
			combineflightData &&
			combineflightData.length > 0 &&
			combineflightData.slice().sort((a, b) => {
				let first = a.Fare
					? Number(
							Number(Math.round(a.Fare.Total_Amount)) -
								Number(Math.round(a.Fare.MFB_Discount))
					  )
					: a.Fares
					? Number(Math.round(a.Fares.Total_Amount))
					: a.totalPriceList
					? Number(Math.round(a.totalPriceList.fd.Total_Amount))
					: a.Supplier === 'MFB'
					? Number(Number(Math.round(a.Total_Amount)))
					: Number(Number(Math.round(a.totalFare)));
				let second = b.Fare
					? Number(
							Number(Math.round(b.Fare.Total_Amount)) -
								Number(Math.round(b.Fare.MFB_Discount))
					  )
					: b.Fares
					? Number(Math.round(b.Fares.Total_Amount))
					: b.totalPriceList
					? Number(Math.round(b.totalPriceList.fd.Total_Amount))
					: b.Supplier === 'MFB'
					? Number(Number(Math.round(b.Total_Amount)))
					: Number(Number(Math.round(b.totalFare)));
				return first - second;
			});
	}
	console.log('filterData', filterData);

	useEffect(() => {
		// dispatch(AddSearchFlightFDDispatch(location.state));
	}, []);
	return (
		<div>
			<Header />
			<Box style={{ background: '#721053', padding: 20 }}>
				<Container>
					<Grid container spacing={3}>
						<Grid item xs={3}>
							<AutoComplete
								style={{ width: '100%', borderRadius: 1 }}
								dropdownMenuStyle={{
									maxHeight: 1000,
									overflowY: 'visible',
									maxWidth: 500,
								}}
								placeholder='From'
								onChange={handleChange}>
								{opsList}
							</AutoComplete>
						</Grid>
						<Grid item xs={3}>
							<AutoComplete
								style={{ width: '100%', borderRadius: 2 }}
								dropdownMenuStyle={{
									maxHeight: 1000,
									overflowY: 'visible',
									maxWidth: 500,
								}}
								placeholder='From'
								onChange={handleChange}>
								{opsList}
							</AutoComplete>
						</Grid>
						<Grid item xs={2}>
							<DatePicker
								onChange={onChange}
								style={{ width: '100%', padding: 8 }}
							/>
						</Grid>{' '}
						<Grid item xs={2}>
							<Button
								onClick={showModal}
								style={{
									textTransform: 'capitalize',
									padding: 7,
									border: '1px solid lightgrey',
									width: '100%',
									height: 'auto',
								}}>
								Traveller Class
							</Button>{' '}
							<Modal
								open={open}
								title='Travellers'
								onOk={handleOk}
								onCancel={handleCancel}
								footer={[
									<Button key='back' onClick={handleCancel}>
										OK
									</Button>,
								]}>
								<Box
									style={{
										display: 'flex',
										justifyContent: 'space-between',
									}}>
									<p>Adults(12+yrs)</p>
									<Box>
										<Button
											style={{
												fontSize: 14,
												background: 'orange',
												color: 'white',
											}}>
											--
										</Button>
										<Button
											style={{
												fontSize: 14,
												background: 'white',
											}}>
											5
										</Button>
										<Button
											style={{
												fontSize: 14,
												background: 'orange',
												color: 'white',
											}}>
											+
										</Button>
									</Box>
								</Box>
								<Box
									style={{
										display: 'flex',
										justifyContent: 'space-between',
									}}>
									<p>Child(2-11yrs)</p>
									<Box>
										<Button
											style={{
												fontSize: 14,
												background: 'orange',
												color: 'white',
											}}>
											--
										</Button>
										<Button
											style={{
												fontSize: 14,
												background: 'white',
											}}>
											5
										</Button>
										<Button
											style={{
												fontSize: 14,
												background: 'orange',
												color: 'white',
											}}>
											+
										</Button>
									</Box>
								</Box>
								<Box
									style={{
										display: 'flex',
										justifyContent: 'space-between',
									}}>
									<p>Infant(0-2yrs)</p>
									<Box>
										<Button
											style={{
												fontSize: 14,
												background: 'orange',
												color: 'white',
											}}>
											--
										</Button>
										<Button
											style={{
												fontSize: 14,
												background: 'white',
											}}>
											5
										</Button>
										<Button
											style={{
												fontSize: 14,
												background: 'orange',
												color: 'white',
											}}>
											+
										</Button>
									</Box>
								</Box>
							</Modal>
						</Grid>
						<Grid item xs={2}>
							<Button
								style={{
									background: '#EC5B24',
									color: 'white',
									width: '100%',
									padding: 7,
									height: 'auto',
								}}>
								Search
							</Button>
						</Grid>
					</Grid>
				</Container>
			</Box>

			<Container>
				<Box
					style={{
						marginTop: 50,
						marginBottom: 50,
						paddingLeft: 100,
						paddingRight: 100,
					}}>
					<Grid container spacing={4}>
						<Grid item xs={12} lg={12}>
							{!loadingfd && !loading ? (
								filterData?.length > 0 ? (
									<InfiniteScroll
										dataLength={scrollVal}
										next={fetchMoreData}
										hasMore={hasMorefilterData}
										loader={<h4 style={{ textAlign: 'center' }}>Loading...</h4>}
										endMessage={
											<p style={{ textAlign: 'center' }}>
												<b>No More Flights</b>
											</p>
										}>
										{filterData?.map((item, index) => {
											return index < scrollVal ? (
												<>
													<Box
														style={{
															display: 'flex',
															justifyContent: 'space-between',
															alignItems: 'center',
															borderRadius: 4,
															background: '#fff',
															filter:
																'drop-shadow(0 2px 4px rgba(0, 0, 0, .25))',
															padding: 30,
															marginTop: 10,
														}}>
														<Box>
															<img
																src={`https://nitish.musafirbazar.com/static/media/${
																	item.Supplier === 'TBO'
																		? item.AirlineCode
																		: item.Supplier === 'ETR'
																		? item.Airline_Code
																		: item.Supplier === 'MFB'
																		? item.Segments[0].Airline.AirlineCode
																		: item?.flight_number?.split(' ')[0]
																}.gif`}
																style={{ height: 50 }}
															/>
															<br></br>
															<span
																style={{
																	color: 'rgba(0,0,0,.38)',
																	fontSize: 12,
																}}>
																{item.Supplier === 'TBO'
																	? item.Segments[0].slice(0, 1).map((i) => {
																			return i.Airline.AirlineName;
																	  })
																	: item.Supplier === 'ETR'
																	? item.Segments[0].Airline_Name
																	: item.Supplier === 'MFB'
																	? item.Segments[0].Airline.AirlineName
																	: item.airline}
															</span>
															<br></br>
															<span
																style={{
																	color: 'rgba(0,0,0,.38)',
																	fontSize: 12,
																}}>
																{`${
																	item.Supplier === 'TBO'
																		? item.AirlineCode
																		: item.Supplier === 'ETR'
																		? item.Airline_Code
																		: item.Supplier === 'MFB'
																		? item.Segments[0].Airline.AirlineCode
																		: item?.flight_number?.split(' ')[0]
																}${
																	item.Supplier === 'TBO'
																		? `${item.Segments[0]
																				.slice(0, 1)
																				.map((i) => {
																					return i.Airline.AirlineCode;
																				})} ${item.Segments[0]
																				.slice(0, 1)
																				.map((i) => {
																					return i.Airline.FlightNumber;
																				})}`
																		: item.Supplier === 'ETR'
																		? `${item.Segments[0].Airline_Code} ${item.Segments[0].Flight_Number}`
																		: item.Supplier === 'MFB'
																		? `${item.Segments[0].Airline.AirlineCode}-${item.Segments[0].Airline.FlightNumber}`
																		: item.flight_number
																}`}
															</span>
														</Box>

														<Box>
															<span
																style={{
																	fontSize: 14,
																	color: 'rgba(0,0,0,.38)',
																}}>
																{item.Supplier === 'TBO'
																	? item.FareRules[0].Origin
																	: item.Supplier === 'ETR'
																	? item.Origin
																	: item.Supplier === 'MFB'
																	? item.Segments[0].Origin.Airport.AirportCode
																	: item.origin}
															</span>
															<br></br>
															<span style={{ fontSize: 26 }}>
																{item.Supplier === 'TBO'
																	? item.Segments[0].slice(0, 1).map((i) => {
																			return i.Origin.DepTime.substr(11, 5);
																	  })
																	: item.Supplier === 'ETR'
																	? item.Segments[0].Departure_DateTime.substr(
																			11,
																			5
																	  )
																	: item.Supplier === 'MFB'
																	? item.Segments[0].Origin.DepTime.substr(
																			11,
																			5
																	  )
																	: item.departure_time}
															</span>
															<br></br>
															<span
																style={{
																	fontSize: 12,
																	color: 'rgba(0,0,0,.38)',
																}}>
																{item.Supplier === 'AIQ'
																	? item.departure_date
																	: item.Supplier === 'TBO'
																	? item.Segments[0].slice(0, 1).map((i) => {
																			return i.Origin.DepTime.split('T')[0];
																	  })
																	: ''}
															</span>
															<br></br>
														</Box>
														<Box textAlign={'center'}>
															<span
																style={{
																	fontSize: 14,
																	color: 'rgba(0,0,0,.38)',
																}}>
																2hr 15min
															</span>
															<br></br>
															<span>-------------------</span>
															<br></br>

															<span>
																{item.AirlineCode
																	? item.Segments[0].length === 1
																		? 'Non Stop'
																		: item.Segments[0].length === 2
																		? '1 Stop'
																		: item.Segments[0].length === 3
																		? '2 Stop'
																		: ''
																	: ''}
															</span>
														</Box>
														<Box>
															<span
																style={{
																	fontSize: 14,
																	color: 'rgba(0,0,0,.38)',
																}}>
																{item.Supplier === 'TBO'
																	? item.Segments[0].length == 2
																		? item.Segments[0]
																				.filter((i, index) => index === 1)
																				.map((it) => {
																					return it.Destination.Airport
																						.AirportCode;
																				})
																		: item.Segments[0].length == 3
																		? item.Segments[0]
																				.filter((i, index) => index === 2)
																				.map((it) => {
																					return it.Destination.Airport
																						.AirportCode;
																				})
																		: item.Segments[0].length == 1
																		? item.Segments[0].map((it) => {
																				return it.Destination.Airport
																					.AirportCode;
																		  })
																		: ''
																	: item.Supplier === 'ETR'
																	? item.Segments.length === 1
																		? item.Segments.filter(
																				(i, index) => index === 0
																		  ).map((it) => {
																				return it.Destination;
																		  })
																		: item.Segments.length === 2
																		? item.Segments.filter(
																				(i, index) => index === 1
																		  ).map((it) => {
																				return it.Destination;
																		  })
																		: item.Segments.length === 3
																		? item.Segments.filter(
																				(i, index) => index === 2
																		  ).map((it) => {
																				return it.Destination;
																		  })
																		: ''
																	: item.Supplier === 'MFB'
																	? item.Segments[0].Destination.Airport
																			.AirportCode
																	: item.destination}
															</span>
															<br></br>
															<span style={{ fontSize: 26 }}>
																{item.Supplier === 'TBO'
																	? item.Segments[0].length == 3
																		? item.Segments[0]
																				.filter((i, index) => index === 2)
																				.map((i) => {
																					return i.Destination.ArrTime.substr(
																						11,
																						5
																					);
																				})
																		: item.Segments[0].length == 2
																		? item.Segments[0]
																				.filter((i, index) => index === 1)
																				.map((i) => {
																					return i.Destination.ArrTime.substr(
																						11,
																						5
																					);
																				})
																		: item.Segments[0].length == 1
																		? item.Segments[0]
																				.filter((i, index) => index === 0)
																				.map((i) => {
																					return i.Destination.ArrTime.substr(
																						11,
																						5
																					);
																				})
																		: ''
																	: item.Supplier === 'ETR'
																	? item.Segments.length === 1
																		? item.Segments.filter(
																				(i, index) => index === 0
																		  ).map((it) => {
																				return it.Arrival_DateTime.substr(
																					11,
																					5
																				);
																		  })
																		: item.Segments.length === 2
																		? item.Segments.filter(
																				(i, index) => index === 1
																		  ).map((it) => {
																				return it.Arrival_DateTime.substr(
																					11,
																					5
																				);
																		  })
																		: item.Segments.length === 3
																		? item.Segments.filter(
																				(i, index) => index === 2
																		  ).map((it) => {
																				return it.Arrival_DateTime.substr(
																					11,
																					5
																				);
																		  })
																		: ''
																	: item.Supplier === 'MFB'
																	? item.Segments[0].Destination.ArrTime.substr(
																			11,
																			5
																	  )
																	: item.arival_time}
															</span>
															<br></br>
															<span
																style={{
																	fontSize: 12,
																	color: 'rgba(0,0,0,.38)',
																}}>
																{item.Supplier === 'AIQ'
																	? item.departure_date
																	: item.Supplier === 'TBO'
																	? item.Segments[0].length == 3
																		? item.Segments[0]
																				.filter((i, index) => index === 2)
																				.map((i) => {
																					return i.Destination.ArrTime.split(
																						'T'
																					)[0];
																				})
																		: item.Segments[0].length == 2
																		? item.Segments[0]
																				.filter((i, index) => index === 1)
																				.map((i) => {
																					return i.Destination.ArrTime.split(
																						'T'
																					)[0];
																				})
																		: item.Segments[0].length == 1
																		? item.Segments[0]
																				.filter((i, index) => index === 0)
																				.map((i) => {
																					return i.Destination.ArrTime.split(
																						'T'
																					)[0];
																				})
																		: ''
																	: ''}
															</span>
															<br></br>
														</Box>
														<h2>
															₹
															{Number(
																Math.round(
																	item.Supplier === 'TBO'
																		? Number(
																				Math.round(
																					Number(
																						Number(
																							Math.round(item.Fare.Total_Amount)
																						) -
																							Number(
																								Math.round(
																									item.Fare.MFB_Discount
																								)
																							)
																					)
																				)
																		  )
																		: item.Supplier === 'ETR'
																		? Number(
																				Math.round(
																					Number(
																						Math.round(item.Fares.Total_Amount)
																					)
																				)
																		  )
																		: item.Supplier === 'MFB'
																		? item.Fare.Total_Amount
																		: item.totalFare
																)
															)}
														</h2>
														<Button
															onClick={() =>
																navigate('/flightbooking', {
																	state: {
																		onward: item,
																		formData: location.state,
																	},
																})
															}
															style={{
																background: '#EC5B24',
																color: 'white',
																width: '18%',
															}}>
															Book
														</Button>
													</Box>
													{/* <Box
												style={{
													alignItems: 'center',
													borderRadius: 4,
													background: '#fff',
													// filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, .25))',
												}}>
												<span>Flight Details</span>
											</Box> */}
												</>
											) : (
												''
											);
										})}
									</InfiniteScroll>
								) : loadinghome ? (
									''
								) : loadingfd || loading ? (
									<h2>No Result Found</h2>
								) : (
									Array.from(Array(10)).map((i) => {
										return <FlightResultSkeleton />;
									})
								)
							) : (
								Array.from(Array(10)).map((i) => {
									return <FlightResultSkeleton />;
								})
							)}
						</Grid>
					</Grid>
				</Box>
			</Container>
			<TopDrawer draw={draw} setDraw={setDraw} />
			<Footer />
		</div>
	);
};

export default SearchResultPromo;
